import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function SortableItem(props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props.id,
    transition: { duration: 350, easing: 'cubic-bezier(0.25, 1, 0.5, 1)' },
    disabled: props.disabled,
  });

  const style = {
    transform: CSS.Transform.toString(
      transform && {
        ...transform,
        scaleX: isDragging ? 0.88 : 1,
        scaleY: isDragging ? 0.88 : 1,
      }
    ),
    transition,
    zIndex: 999,
    cursor: props.disabled ? 'default' : 'move',
  };

  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={props.className || ''}
      title={props.title || ''}
    >
      {props.children}
    </li>
  );
}
